import styled from '@emotion/styled';
import { Stack } from '@hotjar/hotsauce';
import { SkeletonLoader } from '../../../../external-dependencies/webapp-utils';

const S = {
  SkeletonLoaderLabel: styled(SkeletonLoader.Line)`
    width: 50%;
  `,
};

export function ChurnSurveyFormLoader(): JSX.Element {
  return (
    <Stack preset="form">
      {/* Skeleton for intro message */}
      <S.SkeletonLoaderLabel size="40px" />
      {/* Skeleton for what is the main reason to downgrade select */}
      <div>
        <S.SkeletonLoaderLabel />
        <SkeletonLoader.Line size="40px" />
      </div>
      {/* Skeleton for textarea */}
      <div>
        <S.SkeletonLoaderLabel />
        <SkeletonLoader.Line size="100px" />
      </div>
      {/* Skeleton for radio question */}
      <div>
        <S.SkeletonLoaderLabel />
        <S.SkeletonLoaderLabel />
      </div>
    </Stack>
  );
}
